import React, { useState, useEffect } from "react";

// Import models
import { Movies } from "../models/Movies";
import { Projections } from "../models/Projections";

// Import services
import { MovieServices } from "../services/MoviesService";
import { ProjectionsServices } from "../services/ProjectionsServices";

// Import components
import MovieInfo from "../components/MovieInfo/MovieInfo";
import Container from "../components/Container/Container";
import ProjectionTermini from "../components/ProjectionTremin/ProjectionTermini";
import {
  ProjectionContainer,
  Headlining,
  Line,
} from "../components/ProjectionSchedule/ProjectionScheduleStyle";

type ProjectionGroup = {
  date: string;
  movies: Movies[];
};

const DisplaySchedulePage = ({ isScreenMode }: Props) => {
  const [projectionGroups, setProjectionGroups] = useState<ProjectionGroup[]>(
    [],
  );
  const days = [
    "Nedjelja",
    "Ponedjeljak",
    "Utorak",
    "Srijeda",
    "Četvrtak",
    "Petak",
    "Subota",
  ];

  useEffect(() => {
    const loadProjectionGroups = async () => {
      const movies: Movies[] = await MovieServices.getAllMovies(1);
      const groupedProjections = new Map<string, Movies[]>();

      await Promise.all(
        movies.map(async (movie) => {
          const movieProjectionDates: Projections[] =
            await ProjectionsServices.getAllDateProjectionsForMovie(
              1,
              movie.id,
            );

          movieProjectionDates.forEach((projectionDate) => {
            const dateKey = projectionDate.date.toString().split("T")[0];
            const moviesForDate = groupedProjections.get(dateKey) ?? [];

            if (!moviesForDate.some(({ id }) => id === movie.id)) {
              groupedProjections.set(dateKey, [...moviesForDate, movie]);
            }
          });
        }),
      );

      setProjectionGroups(
        Array.from(groupedProjections.entries())
          .sort(([firstDate], [secondDate]) =>
            firstDate.localeCompare(secondDate),
          )
          .map(([date, groupedMovies]) => ({
            date,
            movies: groupedMovies,
          })),
      );
    };

    loadProjectionGroups();
  }, []);

  return (
    <>
      {projectionGroups.length > 0 ? (
        projectionGroups.map((projectionGroup) => (
          <>
            <Headlining isScreenMode={isScreenMode} key={projectionGroup.date}>
              {days[new Date(projectionGroup.date).getDay()] + " "}
              {projectionGroup.date.split("-").reverse().join(".")}
            </Headlining>
            {projectionGroup.movies.map((movie) => (
              <React.Fragment key={`${projectionGroup.date}-${movie.id}`}>
                <Container isScreenMode={isScreenMode}>
                  <MovieInfo
                    movie={movie}
                    isShowVideo={false}
                    isScreenMode={isScreenMode}
                  />
                </Container>
                <ProjectionContainer>
                  <ProjectionTermini
                    movieId={movie.id}
                    date={new Date(projectionGroup.date)}
                    isScreenMode={isScreenMode}
                  />
                </ProjectionContainer>
                <Line />
              </React.Fragment>
            ))}
          </>
        ))
      ) : (
        <></>
      )}
    </>
  );
};

export default DisplaySchedulePage;

type Props = {
  isScreenMode: boolean;
};
